// React Context
import { useContext, createContext, useEffect, useState } from 'react'

// Firebase Functionality 
import { collection, deleteDoc, getDocs, doc } from 'firebase/firestore'
import { db } from "../firebase.js"

const PortfolioData = createContext()

export function PortfolioProvider({ children }) {

    const [portfolioList, setPortfolioList] = useState(null)
    const portfolioCollectionRef = collection(db, "portfolios")
    const [loading, setLoading] = useState(true)

    // check for portfolios 
    useEffect(() => {
        try{
        const getPortfolios = async () => {
            const data = await getDocs(portfolioCollectionRef)
            setPortfolioList(data.docs.map((doc) => ({...doc.data(), id: doc.id })))
            setLoading(false)
            console.log(portfolioList)
        }
        getPortfolios()
    } catch(error) {
        console.log(error)
    }
    }, [!portfolioList])


  return (
    <PortfolioData.Provider value={{portfolioList}}>
        {!loading && children }
    </PortfolioData.Provider>
  )
}

export const PortfolioContext = () => {
    return useContext(PortfolioData)
}